import { gql } from '@apollo/client';
import React, { useEffect } from 'react';
import { Stack, Button, Text } from '@moda/om';
import { useModuleTracking } from '../../hooks/useModuleTracking';
import { PumoLivestreamModuleFragment } from '../../generated/types/PumoLivestreamModuleFragment';
import { loadBambuser } from '../../lib/bambuser';
import { MINUTES_TO_SECONDS, SECONDS_TO_MILLISECONDS } from '../../constants/time';
import { PumoModuleSlide, PUMO_MODULE_SLIDE_FRAGMENT } from '../PumoModuleSlide';
import { RestrictPlatform } from '../RestrictPlatform';

import './PumoLivestreamModule.scss';

export interface Props {
  livestream: PumoLivestreamModuleFragment;
}

export const PUMO_LIVESTREAM_MODULE_FRAGMENT = gql`
  fragment PumoLivestreamModuleFragment on LivestreamPumoModule {
    id
    name
    platforms: platform
    slides {
      ...PumoModuleSlideFragment
    }
    livestreamId: livestream_id
    headlineBody: headline_body
    ctaBeforeShowText: cta_before_show_text
    ctaBeforeShowUrl: before_cta_url
    ctaAfterShowText: cta_after_show_text
    startDate: start_date
  }
  ${PUMO_MODULE_SLIDE_FRAGMENT}
`;

export const PumoLivestreamModule: React.FC<Props> = ({
  livestream: {
    livestreamId,
    name,
    startDate,
    platforms,
    slides,
    headlineBody,
    ctaAfterShowText,
    ctaBeforeShowText,
    ctaBeforeShowUrl
  }
}) => {
  useEffect(() => {
    loadBambuser(livestreamId);
  }, [livestreamId]);

  const { ref } = useModuleTracking({ name: name });

  const timeZone = new Date(startDate.replace(/\s+/g, 'T') + 'Z');
  const timeOffset = new Date().getTimezoneOffset();
  const formattedDate = new Date(
    timeZone.getTime() + timeOffset * MINUTES_TO_SECONDS * SECONDS_TO_MILLISECONDS
  );

  return (
    <RestrictPlatform platforms={platforms}>
      <div className="PumoLivestreamModule" ref={ref}>
        <div>
          {slides.map((slide, index) => (
            <PumoModuleSlide key={index} slide={slide} className="PumoLivestreamModule__image" />
          ))}
        </div>
        <Stack className="PumoLivestreamModule__side" space={4} justifyContent="center">
          <Text
            dangerouslySetInnerHTML={{
              __html: headlineBody
            }}
          />
          {formattedDate < new Date() ? (
            <Button className="PumoLivestreamModule__button" id={`liveshopping-${livestreamId}`}>
              {ctaAfterShowText}
            </Button>
          ) : ctaBeforeShowUrl !== '' ? (
            <Button
              className="PumoLivestreamModule__button"
              href={ctaBeforeShowUrl}
              rel="noopener noreferrer"
              target="_blank"
            >
              {ctaBeforeShowText}
            </Button>
          ) : (
            <Button className="PumoLivestreamModule__button" id={`liveshopping-${livestreamId}`}>
              {ctaBeforeShowText}
            </Button>
          )}
        </Stack>
      </div>
    </RestrictPlatform>
  );
};
